import React, { FC, Fragment, Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Backdrop, Fab, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddCommentIcon from '@material-ui/icons/AddComment';

import { Events } from 'analytics';
import { Loaders } from 'components';
import { useDiscussions } from 'hooks';

const useStyles = makeStyles(theme => ({
  fab: {
    position: 'fixed',
    boxShadow: theme.shadows[2],
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.snackbar,
  },
  backdrop: {
    zIndex: theme.zIndex.modal - 2,
  },
  text: {
    marginRight: theme.spacing(),
    textTransform: 'none',
    color: theme.palette.common.white,
  },
  icon: {
    color: theme.palette.common.white,
  },
}));

const MessagingLauncher: FC = () => {
  const classes = useStyles();
  const { context, onOpen, onClose } = useDiscussions();
  const { t } = useTranslation();
  const { open } = context;

  function handleOpen() {
    analytics.track(Events.ViewDiscussionMenu);
    onOpen();
  }

  function renderFab() {
    return (
      <Fab variant="extended" color="secondary" className={classes.fab} onClick={handleOpen}>
        <Typography className={classes.text}>{t('common:discussion_plural')}</Typography>
        <AddCommentIcon className={classes.icon} />
      </Fab>
    );
  }

  function renderLoader() {
    return (
      <Fab variant="extended" color="secondary" className={classes.fab} onClick={handleOpen}>
        <Typography component="span" className={classes.text}>
          <Loaders.Standard height={30} width={72} />
        </Typography>
        <AddCommentIcon className={classes.icon} />
      </Fab>
    );
  }

  function renderMessages() {
    const DiscussionsPanel = lazy(() => import('./Panel'));

    return (
      <Suspense fallback={renderLoader()}>
        <DiscussionsPanel />
      </Suspense>
    );
  }

  return (
    <Fragment>
      <Backdrop onClick={onClose} className={classes.backdrop} open={open} />
      {open ? renderMessages() : renderFab()}
    </Fragment>
  );
};

export default MessagingLauncher;
